<template lang="pug">
  div
    el-row.labelStyle
      el-col(:span="12")
        app-display(label="CEP:" :content="dadosJson.contato.cep || '-'")
        app-display(label="Estado:" :content="dadosJson.contato.estado || '-'")
        app-display(label="Logradouro:" :content="dadosJson.contato.logradouro || '-'")
      el-col(:span="12")
        app-display(label="Bairro:" :content="dadosJson.contato.bairro || '-'")
        app-display(label="Telefones:")
        ul
          li(v-for="telefone in dadosJson.contato.telefones" :key="telefone") {{ telefone }}

</template>

<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => `${telefone}`).join('            ')
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ContatoUc.vue